import React from 'react';

import { RoomTypeID } from '@kamernet/core/ApiClient/Kamernet';

import { ContentStreetAntisquat } from './ContentStreetAntisquat';
import { ContentStreetApartment } from './ContentStreetApartment';
import { ContentStreetGeneric } from './ContentStreetGeneric';
import { ContentStreetRoom } from './ContentStreetRoom';
import { ContentStreetStudentHousing } from './ContentStreetStudentHousing';
import { ContentStreetStudio } from './ContentStreetStudio';

export interface ContentStreetProps {
  streetName: string;
  cityName: string;
  listingTypeIds: RoomTypeID[];
}

export const ContentStreet = ({
  streetName,
  cityName,
  listingTypeIds,
}: ContentStreetProps) => {
  if (listingTypeIds.length !== 1) {
    return <ContentStreetGeneric streetName={streetName} cityName={cityName} />;
  }

  switch (listingTypeIds[0]) {
    case RoomTypeID.Room:
      return <ContentStreetRoom streetName={streetName} cityName={cityName} />;
    case RoomTypeID.Apartment:
      return (
        <ContentStreetApartment streetName={streetName} cityName={cityName} />
      );
    case RoomTypeID.Studio:
      return (
        <ContentStreetStudio streetName={streetName} cityName={cityName} />
      );
    case RoomTypeID.Antikraak:
      return (
        <ContentStreetAntisquat streetName={streetName} cityName={cityName} />
      );
    case RoomTypeID.StudentResidence:
      return (
        <ContentStreetStudentHousing
          streetName={streetName}
          cityName={cityName}
        />
      );
    default:
      return (
        <ContentStreetGeneric streetName={streetName} cityName={cityName} />
      );
  }
};
